module.exports = "/_next/static/images/d30eb38ba6e7d1fc76af7c88dea2e264-mulher-com-cachos-maravilhosos-segurando-cartao-xs@2x.jpg.webp";